module.exports = __webpack_public_path__ + "media/country_flags/af-7c300243.png";